import { Link } from "react-router-dom";
import { isClinic } from "../lib/site";

// Clinic customers who tap the top-left logo are sent to the marketing
// landing page for teeth whitening on the main WhiteSmileClinic.ie site
// (not back to step 1 of the booking wizard). Dental keeps historic
// behaviour — logo click resets the wizard to /.
const CLINIC_LOGO_URL = "https://whitesmileclinic.ie/teeth-whitening-learn-more/";

export default function SiteHeader({ summary = null }) {
  const clinic = isClinic();

  const logoImg = clinic ? (
    <img
      src="https://customer-assets-39nsmqrw.emergentagent.net/job_teeth-reserve-2/artifacts/ge2az69r_wscLogo2022.webp"
      alt="White Smile Clinic"
      className="h-10 sm:h-11 w-auto rounded-md"
      data-testid="site-logo-clinic"
    />
  ) : (
    <img
      src="https://customer-assets.emergentagent.com/job_teeth-reserve-2/artifacts/2rmaj567_wsdLogo2022.png"
      alt="White Smile Dental"
      className="h-10 sm:h-11 w-auto rounded-md"
      data-testid="site-logo-image"
    />
  );

  return (
    <header
      className="sticky top-0 z-50 backdrop-blur-xl bg-white/80 border-b border-[#E5E5E5]"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-4">
        {clinic ? (
          <a
            href={CLINIC_LOGO_URL}
            className="flex items-center flex-shrink-0"
            data-testid="site-logo-link"
          >
            {logoImg}
          </a>
        ) : (
          <Link to="/" className="flex items-center flex-shrink-0" data-testid="site-logo-link">
            {logoImg}
          </Link>
        )}

        {summary && summary.length > 0 && (
          <div
            className="hidden sm:flex flex-col text-right text-xs text-[#5C5C5C] leading-tight max-w-[55%] overflow-hidden"
            data-testid="booking-header-summary"
          >
            {summary.slice(0, 3).map((line, i) => (
              <div key={i} className="truncate">{line}</div>
            ))}
          </div>
        )}
      </div>
      {summary && summary.length > 0 && (
        <div className="sm:hidden border-t border-[#F0F0F0] bg-white/60 px-4 py-1.5 text-[11px] text-[#5C5C5C] leading-tight" data-testid="booking-header-summary-mobile">
          {summary.slice(0, 3).map((line, i) => (
            <div key={i} className="truncate">{line}</div>
          ))}
        </div>
      )}
    </header>
  );
}
